import { Controller } from "@hotwired/stimulus"

// Selection state for the shared neighbor picker.
//
// Replaces the AlpineJS `x-data="{ selected: null }"` this markup used to carry
// in two places. ADR-0015 puts new interactivity on Stimulus, and the picker is
// about to gain a third consumer.
//
// Results arrive in a Turbo Frame after this controller connects, so selection
// is delegated from the root rather than bound to option targets.
export default class extends Controller {
  static targets = ["field", "submit"]

  declare readonly fieldTarget: HTMLInputElement
  declare readonly submitTarget: HTMLButtonElement
  declare readonly hasSubmitTarget: boolean

  connect() {
    this.syncSubmit()
  }

  select(event: Event) {
    const option = (event.target as HTMLElement).closest<HTMLElement>("[data-neighbor-id]")
    if (!option) return

    this.element
      .querySelectorAll("[data-neighbor-id]")
      .forEach((el) => el.classList.toggle("!bg-slate-200", el === option))

    this.fieldTarget.value = option.dataset.neighborId ?? ""
    this.syncSubmit()
  }

  private syncSubmit() {
    if (this.hasSubmitTarget) this.submitTarget.disabled = this.fieldTarget.value.length === 0
  }
}
